import React from "react";
import {Row, Col, Alert, Image, Container} from "react-bootstrap";
import {useTranslation} from "react-i18next";

const BIMIResult = ({bimiData}) => {
    const {t} = useTranslation();

    const getBorderClass = (protocol) => {
        for (const p of protocol) {
            if (p.issues.length > 0) return "border border-danger-subtle";
            if (p.warnings.length > 0) return "border border-warning-subtle";
        }
        return "border border-success-subtle";
    };

    // Ensure bimiData is an array and check if there is at least one entry
    if (!Array.isArray(bimiData) || bimiData.length === 0) {
        return (
            <Row className="text-center mt-5">
                <Col>
                    <Alert variant="warning">⚠️ {t("pages.analyzeResults.bimi.warningMessage")}</Alert>
                </Col>
            </Row>
        );
    }

    // Find the first BIMI record that contains a logo (mechanism "l")
    const firstValidBimi = bimiData.find((record) =>
        record.mechanisms.some((m) => m.key === "l")
    );

    // Extract logo URL if found
    const logoMechanism = firstValidBimi?.mechanisms.find((m) => m.key === "l");
    const logoUrl = logoMechanism ? logoMechanism.value : null;

    return (
        <>
            <Row className="mt-4 d-flex justify-content-center">
                <Col
                    className={`border-0 border rounded flex-column d-flex align-items-center pt-3 pb-3 justify-content-start`}>
                    <h4>{t('pages.analyzeResults.bimi.title')}</h4>
                    <p className="small text-center">
                        {logoUrl
                            ? `✅ ${t("pages.analyzeResults.bimi.successMessage")}`
                            : `⚠️ ${t("pages.analyzeResults.bimi.warningMessage")}`}
                    </p>
                    {logoUrl && (
                        <Image src={logoUrl} alt="BIMI Logo" fluid style={{maxHeight: "100px"}}/>
                    )}
                </Col>
            </Row>
        </>
    );
};

export default BIMIResult;